import { useEffect } from 'react';

export const useInterval = (handler: VoidFunction, timeout: number) => {
  useEffect(() => {
    const intervalId = setInterval(handler, timeout);

    return () => clearInterval(intervalId);
  }, [handler, timeout]);
};
